// extracted by mini-css-extract-plugin
export default {"contents":"RG-z","sectionHeading":"SG-z"};